export const BleedingDisorderSeverityOptions = [
    { value: "Severe", label: "Severe" },
    { value: "Mild", label: "Mild" },
    { value: "Moderate", label: "Moderate" },
    { value: "N/A", label: "N/A or Unsure" },
];